import React from "react";
import Chats from "../Chats/ChatsScreenContainer";
import { HomeModeContext } from "./HomeModeContext";
import useWorkspaces from "../../Hooks/useWorkspaces";

const HomeScreenContainer = () => {
  const { getActiveWorkspace, getAgent } = useWorkspaces();
  const workspace = getActiveWorkspace();
  
  const defaultChatAgentId = workspace?.defaultChatAgent;
  const agent = defaultChatAgentId ? getAgent(defaultChatAgentId) : null;
  const conciergeAgentId = (agent && !agent?._deleted) ? defaultChatAgentId : 'tf_main';
  
  return (
    <HomeModeContext.Provider
      value={{
        isHomeMode: true,
        agentId: conciergeAgentId,
        routeBase: "home",
        filterByUser: true,
      }}
    >
      <Chats />
    </HomeModeContext.Provider>
  );
};

export default HomeScreenContainer;
